var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDownOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99256 0.125H0.756307C0.0836503 0.125 -0.252404 0.939023 0.22201 1.41344L3.84506 5.15406C3.98943 5.30117 4.15896 5.375 4.37498 5.375C4.56783 5.375 4.76107 5.30109 4.909 5.15327L8.52658 1.41264C9.00154 0.939844 8.66521 0.125 7.99256 0.125Z",
    fill: "#009DE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownOutlined);
export default __webpack_public_path__ + "static/media/caretDownOutlined.cc0903ae478771950451ad9a9b44d95b.svg";
export { ForwardRef as ReactComponent };